import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

const LoadingState: React.FC = () => (
  <LoadingStateWrapper className={styles.widgetRow}>
    <Skeleton variant="rectangular" height="30px" width="300px" animation="pulse" />
    <Skeleton variant="rectangular" height="21px" width="180px" animation="pulse" />
  </LoadingStateWrapper>
);

export default LoadingState;
